import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { Value } from '@philips-internal/oswald-ui-core';
import { Inject } from '@odinjs/odin';
import { ButtonAPI, DeckAPI, TextAPI, ToastService } from '@philips-internal/oswald-ui-components';
import BaseController from '../../BaseController';
import { Endpoint } from '../../../constants/endpoints';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import moment from 'moment';
import { Placement, ToastLevel, ToastType } from '@philips-internal/oswald-ui-constants';
import { PhysicianScheduleAppointmentsDetailAliases as Alias, FragmentNames,  } from '../../../codegen';
import { ApplicationRoute } from '../../../constants/routes';
import { applicationContext, foundationContext } from '@philips-internal/oswald-ui-foundation';
import { cast } from '../../../utils/cast-helper';

@Controller({ component: Alias.APPOINTMENTS_DETAIL_LAYOUT, fragment: FragmentNames.PHYSICIAN_SCHEDULE_APPOINTMENTS_DETAIL })
class PhysicianScheduleAppointmentDetailController extends BaseController {

  @Inject(Alias.APPOINTMENT_DETAIL_DECK)
  private physicanScheduleDeckApi!: DeckAPI;

  @Inject(Alias.APPOINTMENT_DETAIL_TITLE)
  private appointmentsTitleApi!: TextAPI;

  @Inject(Alias.BUTTON_PEP)
  private pepButtonApi!: ButtonAPI;

  @OnMount({target: Alias.APPOINTMENT_DETAIL_DECK})
  onMountDeck(): void {
    const { establishmentCode, scheduleSequence, scheduleType } = this.historyService.getCurrentRouteParams();
    this.physicanScheduleDeckApi.setLoading(true);
    HttpService.get(Endpoint.GET_PHYSICIAN_SCHEDULE_DETAIL, {establishmentCode, scheduleSequence, scheduleType})
      .then(response => {
        const responseBody = response.body as Record<string, Value>;

        this.context.set({ encounterCode: responseBody.encounterCode, patientCode: responseBody.patientCode });
        this.showPepButton();

        this.physicanScheduleDeckApi.setData([responseBody]);
        this.appointmentsTitleApi.setValue(`${moment(String(responseBody.scheduleDate)).utc().format('DD MMMM')} ${responseBody.scheduleStartTime} - ${responseBody.scheduleEndTime}`);
      }).catch((err) => {
        const message = err.body?.errors[0];
        message && this.showToast(message);
      })
      .finally(() => this.physicanScheduleDeckApi.setLoading(false));
  }

  private showToast(value: string ): void {
    return ToastService.open({
      dismissible: true,
      highlight: false,
      id: 'physician-schedule-appointment-detail',
      level: ToastLevel.ERROR,
      message: value,
      placement: Placement.BOTTOM,
      showIcon: true,
      timeout: 5000,
      type: ToastType.BANNER,
    });
  }

  private showPepButton(): void {
    const encounterCode = this.context.get('encounterCode');
    const patientCode = this.context.get('patientCode');
    const modules = foundationContext.getAvailableModules();
    const hasPepAccess = modules?.find((module) => module.id === 'PEP#9127');
    this.pepButtonApi.setVisible(encounterCode && patientCode && hasPepAccess);
  }

  @OnClick({ target: Alias.BUTTON_PEP })
  onClickPepButton(): void {
    const encounterCode = this.context.get('encounterCode');
    const patientCode = this.context.get('patientCode');

    applicationContext.openModule('PEP#9127', {
      at: {
        params: cast({ patientId : patientCode, encounterId: encounterCode }),
        path: ApplicationRoute.ELECTRONIC_PATIENT_CHART_DETAIL,
      }
    });
  }
}

export default PhysicianScheduleAppointmentDetailController;
